module.exports = __webpack_public_path__ + "static/img/5.151aadd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/裤子/5.png
// module id = 7Duc
// module chunks = 0